// import { Injectable, inject } from '@angular/core';
// import { HttpClient } from '@angular/common/http';

// function normalizeBase(url: string | undefined) {
//   if (!url) return '/';
//   return url.endsWith('/') ? url : url + '/';
// }

// @Injectable({ providedIn: 'root' })
// export class ApiService {
//   private http = inject(HttpClient);

//   /** Base URL from Vite env */
//   public readonly mainApiURL = normalizeBase(import.meta.env.VITE_API_URL);

//   // Area roots
//   public readonly authURL = `${this.mainApiURL}Auth/`;
//   public readonly memberProfileURL = `${this.mainApiURL}MemberProfile/`;
//   public readonly AdminProfileURL = `${this.mainApiURL}AdminProfile/`;
//   public readonly memberURL = `${this.mainApiURL}Member/`;


//   public readonly membershipURL = `${this.mainApiURL}Membership/`;
//   public readonly documentsURL = `${this.mainApiURL}Documents/`;
//   public readonly AdminURL = `${this.mainApiURL}Admin/`;
//   public readonly AdminIndicators = `${this.mainApiURL}AdminIndicators/`;
//   public readonly AdminMembership = `${this.mainApiURL}AdminMembership/`;
//   public readonly userProfileURL = `${this.mainApiURL}UserProfile/`;
// }




import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

function normalizeBase(url: string | undefined) {
  if (!url) return '/';
  return url.endsWith('/') ? url : url + '/';
}

type ControllerKey =
  | 'Auth'
  | 'Member'
  | 'MemberProfile'
  | 'AdminProfile'
  | 'Membership'
  | 'Documents'
  | 'Admin'
  | 'AdminIndicators'
  | 'AdminMembership'
  | 'UserProfile';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private http = inject(HttpClient);

  /** Base URL from Vite env */
  public readonly mainApiURL = normalizeBase(import.meta.env.VITE_API_URL);

  /** Central organized controller roots */
  public readonly controllers: Record<ControllerKey, string> = {
    Auth: `${this.mainApiURL}Auth/`,
    Member: `${this.mainApiURL}Member/`,
    MemberProfile: `${this.mainApiURL}MemberProfile/`,
    AdminProfile: `${this.mainApiURL}AdminProfile/`,
    Membership: `${this.mainApiURL}Membership/`,
    Documents: `${this.mainApiURL}Documents/`,
    Admin: `${this.mainApiURL}Admin/`,
    AdminIndicators: `${this.mainApiURL}AdminIndicators/`,
    AdminMembership: `${this.mainApiURL}AdminMembership/`,
    UserProfile: `${this.mainApiURL}UserProfile/`,
  };

  // ✅ Backward compatible existing properties (do not remove)
  public readonly authURL = this.controllers.Auth;
  public readonly memberProfileURL = this.controllers.MemberProfile;
  public readonly AdminProfileURL = this.controllers.AdminProfile;
  public readonly memberURL = this.controllers.Member;

  public readonly membershipURL = this.controllers.Membership;
  public readonly documentsURL = this.controllers.Documents;
  public readonly AdminURL = this.controllers.Admin;
  public readonly AdminIndicators = this.controllers.AdminIndicators;
  public readonly AdminMembership = this.controllers.AdminMembership;
  public readonly userProfileURL = this.controllers.UserProfile;
}